<template>
    <v-row justify="center">
        <v-alert type="error" dismissible v-model="showErrorAlert" transition="scale-transition"
                 style="position: fixed;
                        z-index: 1000;
                        top: 100px;
                        margin: auto!important;
                        left: 50%;
                        transform: translateX(-50%);
                        max-width: 700px;">
            {{ textError }}
            <template v-slot:close="{ toggle }">
                <v-icon
                        small
                        @click="handleClose(toggle)"
                        title="Close"
                        class="ml-2"
                >
                    mdi-close
                </v-icon>
            </template>
        </v-alert>
    </v-row>
</template>

<script>
    export default {
        name: "Alert",
        props: {
            showErrorAlert: {
                type: Boolean
            },
            textError: {
                type: String
            },
        },
        methods: {
            handleClose(toggle) {
                this.$emit("onClose");
                toggle();
            }
        }
    }
</script>
